import BackboneEvents from './backbone.events';

/**
 * Simple syntactic sugar for easier extending objects with events
 */
class Eventable {}
Object.assign(Eventable.prototype, BackboneEvents);

export default Eventable;